import styled from "styled-components";
import { spacing } from "../../../design-system/tokens/spacing";

/**
 * Section wrapper — no decoration. Each `DetailField boxed` already carries
 * its own border + radius (Figma `--stroke-200` 12px), so an outer card
 * would create a redundant double border around the grid.
 */
export const Card = styled.section`
  display: block;
`;

/**
 * 3-column grid that wraps to 2 columns on narrow viewports. Uses
 * grid-row gaps for vertical breathing between the two field rows.
 */
export const FieldsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  column-gap: ${spacing[6]};
  row-gap: ${spacing[5]};

  @media (max-width: 720px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
`;
